module.exports = __webpack_public_path__ + "static/media/git.7c3933e2.png";